// src/components/SlotMachine.js

import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import 'animate.css';
import './style.css'
import { isMobile } from 'react-device-detect';

const SlotColumn = (props) => {
  const { currentValue, stoped, spinning } = props
  const [boxClass, setBoxClass] = useState('')
  const [scollerRange, setScollerRange] = useState([0, -100, 100])

  useEffect(() => {
    if(isMobile){
      setScollerRange([0, -50, 50])
    }
  }, [])

  useEffect(() => {
    if(spinning){
      setTimeout(() => {
        setBoxClass('animate__animated animate__flash')
        setTimeout(() => {
          setBoxClass('')
        }, 1000);
      }, 3500);
    }
  }, [spinning])

  return (
    <div className={`${boxClass} opt-container`}>
      <div className='opt-inner-container'>
        <motion.div
          // key={index}
          className="scoller"
          // style={}
          animate={stoped || !spinning ? { y: 0 } : { y: scollerRange }}
          transition={stoped ? { duration: 0 } : { duration: 0.1, repeat: Infinity, ease: "easeInOut" }}
        >
          {currentValue}
        </motion.div>
      </div>
    </div>
  );
};

export default SlotColumn;
